import { render, staticRenderFns } from "./drop.vue?vue&type=template&id=0367bf1a&scoped=true&"
import script from "./drop.vue?vue&type=script&lang=js&"
export * from "./drop.vue?vue&type=script&lang=js&"
import style0 from "./drop.vue?vue&type=style&index=0&id=0367bf1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0367bf1a",
  null
  
)

export default component.exports